import { useState } from "react";
import { useDispatch } from "react-redux";
import { constants } from "redux/briefings/actions";
import { commonConstants } from "redux/common/actions";
import { getFormattedUser } from "services/auth";
import debounceFunction from "views/utils/debounceFunction";

const {
  FETCH_BRIEFING,
  FETCH_BRIEFING_LIST,
  DELETE_BRIEFING,
  UPDATE_BRIEFING_SEARCH_QUERY,
  NEXT_BRIEFINGS_PAGE,
  PREV_BRIEFINGS_PAGE,
  LAST_BRIEFINGS_PAGE,
  FIRST_BRIEFINGS_PAGE,
} = constants;
const { REQUEST } = commonConstants;

export const useBriefings = () => {
  const dispatch = useDispatch();
  const [hasAdmin, setHasAdmin] = useState(false);

  const fetchBriefings = () => {
    dispatch({
      type: FETCH_BRIEFING_LIST + REQUEST,
      source: FETCH_BRIEFING_LIST,
    });
  };

  const fetchBriefing = (id) => {
    dispatch({
      type: FETCH_BRIEFING + REQUEST,
      payload: { id },
    });
  };

  const debouncedSearch = debounceFunction(1000, fetchBriefings);
  let searchTimeoutID = null;

  const checkAdminPrivileges = async () => {
    const user = await getFormattedUser();
    setHasAdmin(
      (user && user.roles.includes("SuperAdmin")) ||
        user.roles.includes("HrAdmin") ||
        user.roles.includes("ProviderAdmin")
    );
  };

  const handleSubmitBriefing = (submitType, id, notes) => {
    dispatch({
      type: submitType + REQUEST,
      payload: { id, notes },
    });
  };

  const handleDeleteBriefing = (id) => {
    dispatch({
      type: DELETE_BRIEFING + REQUEST,
      payload: { id },
    });
  };

  const handleSearchChange = (event) => {
    dispatch({
      type: UPDATE_BRIEFING_SEARCH_QUERY,
      value: event.target.value,
    });
    dispatch({ type: FIRST_BRIEFINGS_PAGE });
    debouncedSearch();
  };

  const handleClearSearch = () => {
    dispatch({
      type: UPDATE_BRIEFING_SEARCH_QUERY,
      value: "",
    });
    dispatch({ type: FIRST_BRIEFINGS_PAGE });
    fetchBriefings();
  };

  const handleNextPage = () => {
    dispatch({ type: NEXT_BRIEFINGS_PAGE });
    fetchBriefings();
  };

  const handlePrevPage = () => {
    dispatch({ type: PREV_BRIEFINGS_PAGE });
    fetchBriefings();
  };

  const handleLastPage = () => {
    dispatch({ type: LAST_BRIEFINGS_PAGE });
    fetchBriefings();
  };

  const handleFirstPage = () => {
    dispatch({ type: FIRST_BRIEFINGS_PAGE });
    fetchBriefings();
  };

  const clearSearchTimeout = () => {
    if (searchTimeoutID) {
      clearTimeout(searchTimeoutID);
    }
  };

  const initializeBriefingsPage = () => {
    fetchBriefings();
    checkAdminPrivileges();
  };

  return {
    hasAdmin,
    handleSubmitBriefing,
    handleDeleteBriefing,
    handleSearchChange,
    handleClearSearch,
    handleNextPage,
    handlePrevPage,
    handleLastPage,
    handleFirstPage,
    fetchBriefing,
    fetchBriefings,
    initializeBriefingsPage,
    clearSearchTimeout,
  };
};
